<template>
  <div class="c-input">
    <label
      class="c-input__label"
      :class="{ 'c-input__label--empty': isDirty }"
      :style="{ color: labelColor }"
      @click="focusInput"
      >{{ $t(label) }}</label
    >
    <div class="c-input__cnt" @click="$emit('onClick', $event)">
      <input
        :type="checkType"
        :value="value"
        @input="onInput"
        @focusin="focusIn"
        @focusout="focusOut"
        @keyup="onKeyUp"
        class="c-input__input"
        :class="{ 'c-input__input--icon-slot': hasIconSlot }"
        ref="input"
        :disabled="disabled"
        :style="{
          color: primaryColor,
          borderBottomColor: isFocused ? primaryColor : ''
        }"
      />
      <div class="c-input__icon" @click="focusInput">
        <slot name="icon"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Input",
  props: {
    type: {
      type: String,
      default: "text"
    },
    value: {
      type: [String, Number],
      required: true
    },
    label: {
      type: String,
      default: "Rispondi qui"
    },
    labelColor: {
      type: String,
      default: ""
    },
    primary: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isFocused: false
    };
  },
  computed: {
    ...mapGetters(["campaign"]),
    checkType() {
      if (this.type === "adress") {
        return "text";
      }
      return this.type;
    },
    isDirty() {
      if (!this.value) {
        return false;
      }
      return this.value.toString().length || this.isFocused;
    },
    primaryColor() {
      if (this.primary) {
        return this.campaign.css_settings.primary;
      }
      return "";
    },
    hasIconSlot() {
      return !!this.$slots["icon"];
    }
  },
  methods: {
    onInput(e) {
      if (this.disabledTyping) {
        e.preventDefault();
        return;
      }
      this.$emit("input", e.target.value);
    },
    focusInput() {
      this.$refs.input.focus();
    },
    focusIn() {
      this.isFocused = true;
      this.$emit("onFocus", true);
    },
    focusOut() {
      this.isFocused = false;
      this.$emit("onFocus", false);
    },
    onKeyUp(e) {
      e.preventDefault();
    }
  },
  beforeUpdate() {
    if (this.type === "date") {
      console.error("You should use component Date instead of normal");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./inputs";
.c-input__icon {
  position: absolute;
  top: 4px;
  right: 4px;
  max-width: 25px;
  overflow: hidden;
  cursor: text;
}
.c-input__input--icon-slot {
  padding-right: 35px;
}
</style>
